/**
 * Copyright 2026 Salesforce, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { uiConfig } from '@/lib/config.ui';

/**
 * Whether the PDP replaces its initial add CTA with an in-cart quantity stepper.
 * The standard experience is the pre-add quantity selector (`pre-select`, the default);
 * merchants opt into the inline stepper by setting `inline`. Furniture enables it by default.
 */
export const usesInlineAddToCartQuantity = (): boolean => uiConfig.pages.product.addToCartQuantityMode === 'inline';
